import {
  GET_SELFIE_LIST,
  GET_SELFIE_LIST_SUCCESS,
  GET_SELFIE_LIST_FAILURE,  
} from '../../modules/constants';

const getSelfieListRequest = (state, action) => {
  return {
    ...state,
    isSelfieLoading: true,
  };
};

const getSelfieListRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.status === 200) {
    return {
      ...state,
      isSelfieLoading: false,
      selfieList: data.data.results,
      selfieCount: data.data.count,
      selfieListPageSize: 100,
    };
  }
  return {
    ...state,
    isSelfieLoading: false,
    selfieList: [],
    selfieCount: 0,
    selfieListPageSize: null,
  };
};

const getSelfieListRequestFailure = (state, action) => {
  return {
    ...state,
    isSelfieLoading: false,
    selfieList: [],
    selfieListPageSize: null,
  };
};

// Action Handlers
const ACTION_HANDLERS = {
  [GET_SELFIE_LIST]: getSelfieListRequest,
  [GET_SELFIE_LIST_SUCCESS]: getSelfieListRequestSuccess,
  [GET_SELFIE_LIST_FAILURE]: getSelfieListRequestFailure,
};

// default initial state
const initialState = {
  isSelfieLoading: false,
  selfieList: [],
  selfieCount: 0,
  selfieListPageSize: null,
};

export default function selfieReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
